import React from "react";
import { useTranslation } from "react-i18next";
import "./lawyers.css";

// title/lead come from the shared SEO copy (copy.lawyers), so the heading
// matches what the server renders for crawlers.
export default function Heading(props) {
  const { t } = useTranslation();
  return (
    <section className="avc-page-hero">
      <div className="container avc-page-hero__inner">
        <span className="avc-eyebrow">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
          {t("lawyers_eyebrow")}
        </span>
        <h1 className="avc-page-hero__title">
          {props.title ||
            (props.state
              ? t("lawyers_title", { state: props.state })
              : t("lawyers_title_all"))}
        </h1>
        <p className="avc-page-hero__lead">{props.lead || t("Description_Lawyer_p")}</p>
        {props.children}
      </div>
    </section>
  );
}
